class SiteElementFilterSingleDropdownRenderer
    extends QueryElement<HTMLElement>
    implements ISiteElementFilterRenderer, ISiteElementCheckItem {
    
    private readonly _filter: SiteElementFilterSingle;
    private readonly _value: ISiteFilterItem;
    
    constructor(filter: SiteElementFilterSingle, value: ISiteFilterItem) {
        super(document.createElement("DIV"));

        this._filter = filter;
        this._value = value;
        
        this.addClass("element-filter-dropdown")
            .addClass("element-hover");

        var header = QueryElement.QueryElement("H2")
            .addClass("element-hover-close")
            .setText(value.name);
    
        this.append(header);
        this.append(this.renderChilds(value.items));

        var element = this.get();
        if (element == null)
            throw "Element not found";
        
        new SiteElementHover(element);
    }

    addValue(value: ISiteFilterItemValue): void {

        this.query(".element-filter-checkitem")
            .all<SiteElementCheckItem, any>(a => a.makeInactive());
        
        this._filter.setValue(value.filterValue);
        this._filter.updateFilterModel(true);
    }
    removeValue(value: ISiteFilterItemValue): void {
        // Do nothing, cannot uncheck
    }
    containsValue(value: ISiteFilterItemValue): boolean {
        return this._filter.getValue() == value.filterValue;
    }

    renderChilds(values: ISiteFilterItemValue[]) {
        let container = QueryElement.QueryElement("UL");
        
        for(let item of values) {
            let containerItem = QueryElement.QueryElement("LI");

            new SiteElementCheckItem(this, item)
                .appendTo(containerItem);
            
            if (item.childs != null) {
                this.renderChilds(item.childs)
                    .appendTo(containerItem);
            }

            container.append(containerItem);
        }

        return container;
    }

    getState() {
        return null;
    }
}